import * as HttpService from "../../../../service/HttpService";


/** 基准曲线  初始化表格  */
export const selectConfiguration = (current,resName,name) => {
    return HttpService.get(HttpService.DOMAIN + "/eleStroeController/selectConfiguration?start="+current+"&resName="+resName+"&userName="+name);
};

export const addConfiguration = (res_id,date,startTime,endTime,meas) => {
    return HttpService.post(HttpService.DOMAIN + "/eleStroeController/addConfiguration?ce_res_id="+res_id+"&date="+date+"&start_time="+startTime+"&end_time="+endTime+"&measPointIdList="+meas);
};

/** 查询有功功率的历史记录**/
export const getStoreCurve = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/realTimeMonitoring/getStoreCurve", params);
};
/** 更改 **/
export const updateConfiguration = (res_id,date,startTime,endTime,meas) => {
    return HttpService.post(HttpService.DOMAIN + "/eleStroeController/updateConfiguration?ce_res_id="+res_id+"&date="+date+"&start_time="+startTime+"&end_time="+endTime+"&measPointIdList="+meas);
};

/** 删除（批量删除设置） **/
export const deleteMessages = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/eleStroeController/deleteMessages", params);
};
/** 曲线查看  */
export const getCureDetail = (id,date,meas,time) => {
    return HttpService.get(HttpService.DOMAIN + "/eleStroeController/getCureDetail?ce_res_id="+id+"&date="+date+"&measPointIdList="+meas+"&time="+time);
};







